module.exports = __webpack_public_path__ + "media/images/venues-share-a0ea14b92a044045dfaeb51aaacd23cc.jpg";